import { useQuery } from '@tanstack/react-query';

import { environmentObservabilityDiscovery } from '@api/sdk.gen';

import { withError } from '@/react-tools/react-query';
import { EnvironmentId } from '@/react/portainer/environments/types';

import { queryKeys } from './queryKeys';

export interface EnvironmentObservabilityResponse {
  enabled: boolean;
  url?: string;
  projectId?: string;
  clusterName?: string;
  clusterId?: string;
}

export function useEnvironmentObservability(environmentId: EnvironmentId) {
  return useQuery(
    queryKeys.observabilityStatus(environmentId),
    () => getEnvironmentObservability(environmentId),
    {
      staleTime: 60 * 1000,
      ...withError('Unable to check observability status'),
    }
  );
}

async function getEnvironmentObservability(
  environmentId: EnvironmentId
): Promise<EnvironmentObservabilityResponse> {
  const { data } = await environmentObservabilityDiscovery({
    path: { id: environmentId },
  });

  return {
    enabled: data.enabled ?? false,
    url: data.url,
    projectId: data.projectId,
    clusterName: data.clusterName,
    clusterId: data.clusterId,
  };
}
